import { baseStoreCreator } from '@/utils/store';

import { IRoleSetup, RoleLevel } from '../../role.types';

export const DEFAULT_VALUES: IRoleSetup = {
  id: '',
  name: '',
  level: RoleLevel.All,
  organizationId: '',
  description: '',
  isAllowedToCreateAnotherRole: false,
  rolesIdsAllowedForCreation: [],
  allowedForContactsByRoleId: [],
  permissions: [],
  fieldLevelAccessId: ''
};

export const useStore = baseStoreCreator<IRoleSetup>(DEFAULT_VALUES);

export default useStore;